import {lazy} from 'react';

const miscRoutes = [
    {
        exact: true,
        path: '/dialog',
        component: lazy(() => import('../dialogs/DemoPage'))
    },
    {
        exact: true,
        path: '/refueler',
        component: lazy(() => import('../views/Refueler'))
    },
    {
        exact: true,
        path: '/codingPlayground',
        component: lazy(() => import('../views/codingPGround/Coding'))
    },
    {
        exact: true,
        path: '/hazard',
        guard: require('../components/HazardGuard').default,
        component: lazy(() => import('../views/Hazard/HazardousAlert'))
    }
];

export default miscRoutes;
